import { call, put, takeEvery } from 'redux-saga/effects'
import {
    downloadReportForQuery_API,
    getAnandaKeyCategory_API,
    getLabTest_API,
    getLabTestCategory_API,
    getReportForQuery_API,
    getSampleDataForCategory_API,
} from '../../../Config/Api';
import { createNotification } from '../../../Config/NotificationToast';
import { instance } from "../../auth/axiosInstance";
import { logOut } from '../../../utils/Helper';

export default function* queryReport() {
    yield takeEvery('GET_ANANDA_KEY_CATEGORY_LIST', getAnandaKeysCategory);
    yield takeEvery('GET_QUERY_REPORT_DATA', getQueryReport);
    yield takeEvery('DOWNLOAD_QUERY_REPORT_DATA', downloadQueryReport);
    yield takeEvery('GET_SAMPLE_DATA_FOR_CATEGORY', getSampleDataForCategory);
    yield takeEvery('GET_LAB_TEST_LIST', getLabTestList);
    yield takeEvery('GET_LAB_TEST_CATEGORY_LIST', getLabTestCategoryList);
}

const getAnandaKeysCategoryApi = async (url) => {
    try {
        const response = await instance.get(url);
        return response;
    } catch (errors) {
        console.log("errors", errors)
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* getAnandaKeysCategory(action) {
    const URL = `${getAnandaKeyCategory_API}`
    try {
        const response = yield call(getAnandaKeysCategoryApi, URL);
        if (response.statusCode === 200) {
            const categoryList = yield call(getLabTestCategoryListApi);
            // const labTests = yield call(getLabTestListApi, { isStatic: 1 });

            yield put({ type: 'GET_ANANDA_KEY_CATEGORY_LIST_SUCCESS', payload: response.data, categoryList: categoryList?.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message)
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_ANANDA_KEY_CATEGORY_LIST_FAILURE', message: response.message });
            }
        }
    } catch (e) {
        console.log(e)
        yield put({ type: 'GET_ANANDA_KEY_CATEGORY_LIST_FAILURE' });
    }
}

const getQueryReportApi = async (data) => {
    try {
        const response = await instance.post(getReportForQuery_API, {
            data,
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* getQueryReport(action) {
    try {

        let data = action.data
        const BODY = {
            "page": data.page || 1,
            "limit": data.pageLimit || 10,
            "filter_text": data.searchText || "",
            "order_by": data.orderBy || "",
            "order_by_type": data.orderByType || "",
            "and_or_operator": data.condition || 'and',
            "include_fields": data.columns?.map(item => {
                return {
                    "table": item.table,
                    "table_name_alias": item.table_name_alias || '',
                    "column_name": item.column_name,
                    "for_unique_key_alias": item.for_unique_key_alias || '',
                    "json_key": item.selected_json_key || '',
                    "row_id": item.row_id || 0,
                    "extra_key": item.extra_key || '',
                    "sub_category": item.selected_json_key_label || '',
                }
            }) || [],
            "filter_fields": data.filter?.map(item => ({
                "table": item.table,
                "table_name_alias": item.table_name_alias || '',
                "column_name": item.column_name,
                "row_id": item.row_id || 0,
                "json_key": item.selected_json_key || '',
                "operator": item.operator,
                "for_unique_key_alias": item.for_unique_key_alias || '',
                "extra_key": item.extra_key || '',
                "sub_category": item.selected_json_key_label || '',
                "data_type": item.data_type || '',
                "value": item.inputValue
            })) || [],

        };
        const response = yield call(getQueryReportApi, BODY);
        if (response.statusCode === 200) {
            yield put({ type: 'GET_QUERY_REPORT_DATA_SUCCESS', payload: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message);
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_QUERY_REPORT_DATA_FAILURE', message: response.message });
            }

        }

    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_QUERY_REPORT_DATA_FAILURE', message: e.message });
    }
}

const downloadQueryReportApi = async (data) => {

    try {
        const response = await instance.post(downloadReportForQuery_API, {
            data,
        }, {
            responseType: 'arraybuffer',
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* downloadQueryReport(action) {
    try {

        let data = action.data
        const BODY = {
            "page": data.page || 1,
            "limit": data.pageLimit || 10,
            "filter_text": data.searchText || "",
            "order_by": data.orderBy || "",
            "order_by_type": data.orderByType || "",
            "and_or_operator": data.condition || 'and',
            "include_fields": data.columns?.map(item => {
                return {
                    "table": item.table,
                    "table_name_alias": item.table_name_alias || '',
                    "column_name": item.column_name,
                    "for_unique_key_alias": item.for_unique_key_alias || '',
                    "json_key": item.selected_json_key || '',
                    "row_id": item.row_id || 0,
                    "extra_key": item.extra_key || '',
                    "sub_category": item.selected_json_key_label || '',
                }
            }) || [],
            "filter_fields": data.filter?.map(item => ({
                "table": item.table,
                "table_name_alias": item.table_name_alias || '',
                "column_name": item.column_name,
                "row_id": item.row_id || 0,
                "json_key": item.selected_json_key || '',
                "operator": item.operator,
                "for_unique_key_alias": item.for_unique_key_alias || '',
                "extra_key": item.extra_key || '',
                "sub_category": item.selected_json_key_label || '',
                "data_type": item.data_type || '',
                "value": item.inputValue
            })) || [],

        };
        const response = yield call(downloadQueryReportApi, BODY);
        if (response instanceof ArrayBuffer) {
            action.data?.onSuccessCallback(response)
            yield put({ type: 'DOWNLOAD_QUERY_REPORT_DATA_SUCCESS' });
        } else {
            createNotification('Unable to download sheet.')
            yield put({ type: 'DOWNLOAD_QUERY_REPORT_DATA_FAILURE' });
        }

    } catch (e) {
        console.log(e);
        yield put({ type: 'DOWNLOAD_QUERY_REPORT_DATA_FAILURE', message: e.message });
    }
}


const getSampleDataForCategoryApi = async (data) => {
    try {
        const response = await instance.post(getSampleDataForCategory_API, {
            data,
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* getSampleDataForCategory(action) {
    try {

        let data = action.data
        const BODY = {
            "table": data.table || "",
            "table_name_alias": data.table_name_alias || "",
            "column_name": data.column_name || "",
            "row_id": data.row_id || 0,
            "json_key": data.selected_json_key || "",
            "sub_category": data.label || "",
            "extra_key": data.extra_key || "",
            "data_type": data.data_type || "",
            "for_unique_key_alias": data.for_unique_key_alias || "",
        };
        const response = yield call(getSampleDataForCategoryApi, BODY);
        if (response.statusCode === 200) {
            yield put({ type: 'GET_SAMPLE_DATA_FOR_CATEGORY_SUCCESS', payload: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message);
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_SAMPLE_DATA_FOR_CATEGORY_FAILURE', message: response.message });
            }

        }

    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_SAMPLE_DATA_FOR_CATEGORY_FAILURE', message: e.message });
    }
}

const getLabTestListApi = async (data) => {
    try {
        const response = await instance.get(`${getLabTest_API}?static=${data.isStatic}&category_id=${data?.cat_id}`, {
            data,
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            // createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            // createNotification('error', errors.response.data.message);
        } else {
            // createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* getLabTestList(action) {
    try {
        let data = action.data
        const response = yield call(getLabTestListApi, data);
        if (response.statusCode === 200) {
            yield put({ type: 'GET_LAB_TEST_LIST_SUCCESS', payload: response.data, cat_name: data.nested_data_level1?.sub_category || data?.cat_name || '' });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message);
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_LAB_TEST_LIST_FAILURE', message: response.message });
            }

        }

    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_LAB_TEST_LIST_FAILURE', message: e.message });
    }
}


const getLabTestCategoryListApi = async (data) => {
    try {
        const response = await instance.get(`${getLabTestCategory_API}?with_test_list=${data?.isTestList ? 1 : 0}`, {
            data,
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* getLabTestCategoryList(action) {
    try {

        let data = action.data
        const response = yield call(getLabTestCategoryListApi, data);
        if (response.statusCode === 200) {
            yield put({ type: 'GET_LAB_TEST_CATEGORY_LIST_SUCCESS', payload: response.data, isTestList: data?.isTestList });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message);
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_LAB_TEST_CATEGORY_LIST_FAILURE', message: response.message });
            }

        }

    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_LAB_TEST_CATEGORY_LIST_FAILURE', message: e.message });
    }
}